__webpack_require__.p = "https://coffeeandjoy.com.br/assinar/";